// Minimal History-API router — a handful of screens don't need a routing library.
import { useEffect, useState } from "react";

export type Route =
  | { name: "list" }
  | { name: "pet"; id: number; tab?: string }
  | { name: "emergency"; chip: string }
  | { name: "scan"; chip?: string };

function parse(path: string, search: string): Route {
  let m = path.match(/^\/pets\/(\d+)\/?$/);
  if (m) return { name: "pet", id: Number(m[1]), tab: new URLSearchParams(search).get("tab") ?? undefined };
  if (/^\/scan\/?$/.test(path)) return { name: "scan", chip: new URLSearchParams(search).get("chip") ?? undefined };
  m = path.match(/^\/emergency\/([\d-]+)\/?$/);
  if (m) return { name: "emergency", chip: m[1] };
  return { name: "list" };
}

export function navigate(to: string, replace = false) {
  if (to === location.pathname + location.search) return;
  history[replace ? "replaceState" : "pushState"](null, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
  if (!replace) window.scrollTo(0, 0);
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parse(location.pathname, location.search));
  useEffect(() => {
    const onPop = () => setRoute(parse(location.pathname, location.search));
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);
  return route;
}
